import React from 'react'
import ReactOnRails from 'react-on-rails'
import { AppContext, useApp } from '~/context/appContext'
import InAppAnnouncementBanner from './InAppAnnouncementBanner'
import InAppAnnouncementModal from './InAppAnnouncementModal'
import '~/tailwind-output.css'

// ReactOnRails.authenticityToken() reads `document`, absent in the prerender context the
// layout mount renders through. Rails passes the token as a prop, so this is the backstop -
// a ReferenceError here would fail the whole page render, not just the bar.
const readMetaCsrf = () => (typeof document === 'undefined' ? null : ReactOnRails.authenticityToken())

// company/jwt/csrf/currentUserEmail come from AppContext; this root always mounts standalone
// (no ambient provider), so the merge below just falls through to props/payload.
//
// `announcements` is an array because ResolveForRequest returns at most one per placement,
// so a bar and a modal can arrive together and neither spends the other's slot.
// Toast provider moved to GlobalLayout (ENG-12178) - this component is content-only now.
const InAppAnnouncementRoot = ({ companyId, jwt, csrf, currentUserEmail, announcements = [] }) => {
  const ambient = useApp()

  // The layout mount passes only { announcements, companyId, jwt }; csrf and currentUserEmail
  // ride on each announcement instead, and without this never reach AppContext.
  const fromPayload = (key) => announcements.find((candidate) => candidate[key])?.[key]

  const contextValue = {
    ...ambient,
    company: ambient.company ?? (companyId ? { id: companyId } : null),
    jwt: ambient.jwt ?? jwt,
    csrf: ambient.csrf ?? csrf ?? fromPayload('csrf') ?? readMetaCsrf(),
    currentUserEmail: ambient.currentUserEmail ?? currentUserEmail ?? fromPayload('currentUserEmail'),
  }

  const forPlacement = (placement) => announcements.find((candidate) => candidate.placement === placement)

  const topBarAnnouncement = forPlacement('top_bar')
  const modalAnnouncement = forPlacement('modal')

  return (
    <AppContext.Provider value={contextValue}>
      {topBarAnnouncement && <InAppAnnouncementBanner {...topBarAnnouncement} />}
      {modalAnnouncement && <InAppAnnouncementModal {...modalAnnouncement} />}
    </AppContext.Provider>
  )
}

export default InAppAnnouncementRoot
